import { isNoU } from "Utils/ObjectUtils";

export const formatNumber = (
  number: number | null | undefined,
  emptyText?: string,
) => {
  if (isNoU(number)) {
    return emptyText ?? "";
  }

  const formatter = new Intl.NumberFormat("cs-CZ", {
    maximumFractionDigits: 5,
  });
  return formatter.format(number ?? 0);
};
